<div class="gift-donation-config" [formGroup]="form">
	<div class="row" *ngIf="isMandatory === false">
		<div class="column small-12">
			<div class="checkboxbutton-wrapper gift-toggle">
				<input type="checkbox" value="1" id="has_gift_donation" formControlName="showForm" (change)="toggleForm(form.controls['showForm'].value)">
				<label for="has_gift_donation" ><span>{{'gift.isGiftDonation' | translate}}</span><i class="twingle-{{ icon }}"></i></label>
			</div>
		</div>
	</div>

	<div class="form-wrapper row" *ngIf="showForm">
		<div class="column small-12">
			<h3 [innerHTML]="'gift.config.headline' | translate"></h3>
			<p [innerHTML]="'gift.config.teaser' | translate"></p>
		</div>
		<div class="column small-12 show-for-small-only">
			<img class="preview" [src]="previewImage" alt="">
		</div>
		<div class="column small-12 medium-8">
			<h4 [innerHTML]="'gift.config.hideamount.headline' | translate"></h4>
			<div class="checkboxbutton-wrapper" [formGroup]="form">
				<input type="checkbox" name="hide-amount" value="1" id="hide-amount" [(ngModel)]="giftData.hideAmount" [ngModelOptions]="{standalone: true}" (ngModelChange)="updatePreviewUrl()">
				<label for="hide-amount"><span [innerHTML]="'gift.config.hideamount' | translate"></span></label>
			</div>

			<h4 *ngIf="products.length > 1" [innerHTML]="'gift.config.select.headline' | translate"></h4>
			<div class="row collapse margin" *ngIf="products.length > 1">
				<div class="column small-12 large-6">
					<selectfield [form]="form" [(model)]="giftData.product" [name]="'gift.product'" [options]="products" (modelChange)="updatePreviewUrl()"></selectfield>
				</div>
				<div class="column small-12 large-6">
					<p class="help">{{'gift.config.select.help' | translate}}</p>
				</div>
			</div>

			<div class="row">
				<textfield [showLabel]="true" [(model)]="giftData.sender" name="gift.sender" [label]="'gift.config.sender' | translate" [error]="'gift.config.sender.error' | translate" [required]="true" [form]="form" [wrapperClass]="'column small-12'" (onBlur)="updatePreviewUrl()" [maxLength]="40"></textfield>
				<messagefield [showLabel]="true" name="gift.message" [(model)]="giftData.message" [maxLength]="300" [label]="'gift.config.message' | translate" [error]="'gift.config.message.error' | translate" [required]="false" [rows]="5" [form]="form" [wrapperClass]="'column small-12'" (onBlur)="updatePreviewUrl()"></messagefield>
			</div>

			<div class="gift-receiver row" *ngFor="let element of giftData.receiver; let i = index">
				<textfield [name]="'gift.receiver.name.' + i" [wrapperClass]="'column ' + (i>0? 'small-11' : 'small-12')" [maxLength]="40" [showLabel]="true" [(model)]="element.name" [label]="(i > 0? 'gift.config.receiver2.name' : 'gift.config.receiver.name') | translate: {item: i+1}" [error]="'gift.config.receiver.error' | translate" [required]="true" [form]="form" (onBlur)="updatePreviewUrl()"></textfield>
				<div class="column small-1" *ngIf="i > 0">
					<a (click)="removeReceiver(i)" (keydown.space)="removeReceiver(i)" tabindex="0"><i class="twingle-X"></i></a>
				</div>
			</div>

			<div class="row" *ngIf="overlayName">
				<div class="column">
					<overlay [name]="'shopgift'" [show]="showOverlay" (onCancel)="cancelOverlay()" (onSubmit)="submitOverlay($event)"></overlay>
				</div>
			</div>

			<button class="button" (click)="addReceiver()" *ngIf="giftData.receiver.length < receiverMax"><i class="twingle-plus1"></i> {{'gift.config.receiver.add' | translate}}</button>
			<p class="hint" [innerHTML]="'gift.config.receiver.add.hint' | translate"></p>

		</div>
		<div class="column small-12 medium-4 show-for-medium">
			<div class="preview-wrapper">
				<img class="preview" *ngIf="previewImage" [src]="previewImage" alt="" [class.is-loading]="previewImageLoad !== false" (load)="previewImageLoad = false">
				<div class="image-loading" *ngIf="previewImageLoad !== false"></div>
			</div>
		</div>
	</div>
</div>
